export default __webpack_public_path__ + "static/media/gal6.e5f2f541.jpg";